import { type Images } from '@neos/app'
import aiWritingAssistantPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistant.svg'
import aiWritingAssistantDarkVersionPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistant.dark.svg'
import aiWritingAssistantTaskPerformerPath from '../../modules/dependencies/NeosAICore/images/AIWritingAssistantTaskPerformer.svg'
import capturePath from '../../modules/Scheduling/images/Capture.svg'
import collapsePath from '../../modules/dependencies/UserPermissions/images/Collapse.svg'
import correctTextPath from '../../modules/dependencies/NeosAICore/images/CorrectText.svg'
import createCustomViewPath from '../../modules/dependencies/UICustomization/images/CreateCustomView.svg'
import createCustomViewDarkVersionPath from '../../modules/dependencies/UICustomization/images/CreateCustomView.dark.svg'
import customViewPath from '../../modules/dependencies/UICustomization/images/CustomView.svg'
import customViewDefaultViewPath from '../../modules/dependencies/UICustomization/images/CustomViewDefaultView.svg'
import customViewFilterPath from '../../modules/dependencies/UICustomization/images/CustomViewFilter.svg'
import customViewGroupsPath from '../../modules/dependencies/UICustomization/images/CustomViewGroups.svg'
import customViewKeyPath from '../../modules/dependencies/UICustomization/images/CustomViewKey.svg'
import customViewPropertyPath from '../../modules/dependencies/UICustomization/images/CustomViewProperty.svg'
import customViewRelationshipPath from '../../modules/dependencies/UICustomization/images/CustomViewRelationship.svg'
import customViewSavePath from '../../modules/dependencies/UICustomization/images/CustomViewSave.svg'
import customViewSelectedPath from '../../modules/dependencies/UICustomization/images/CustomViewSelected.svg'
import customViewSetDefaultViewPath from '../../modules/dependencies/UICustomization/images/CustomViewSetDefaultView.svg'
import customViewSortPath from '../../modules/dependencies/UICustomization/images/CustomViewSort.svg'
import downPath from '../../modules/dependencies/UserPermissions/images/Down.svg'
import editCustomViewPath from '../../modules/dependencies/UICustomization/images/EditCustomView.svg'
import editCustomViewDarkVersionPath from '../../modules/dependencies/UICustomization/images/EditCustomView.dark.svg'
import endTimePath from '../../modules/Scheduling/images/EndTime.svg'
import errorClusterPath from '../../modules/dependencies/UserPermissions/images/ErrorCluster.svg'
import expandPath from '../../modules/dependencies/UserPermissions/images/Expand.svg'
import externalClusterPath from '../../modules/dependencies/UserPermissions/images/ExternalCluster.svg'
import improveTextPath from '../../modules/dependencies/NeosAICore/images/ImproveText.svg'
import jobAndTriggersTestsPath from '../../modules/QuartzNET/images/JobAndTriggersTests.svg'
import jobAndTriggersTestsDarkVersionPath from '../../modules/QuartzNET/images/JobAndTriggersTests.dark.svg'
import omniaPath from '../../modules/dependencies/NeosAICore/images/Omnia.svg'
import performTaskOnTextPath from '../../modules/dependencies/NeosAICore/images/PerformTaskOnText.svg'
import quartzNetTriggerPath from '../../modules/QuartzNET/images/QuartzNetTrigger.svg'
import quartzNetTriggerDarkVersionPath from '../../modules/QuartzNET/images/QuartzNetTrigger.dark.svg'
import queryaPath from '../../modules/dependencies/NeosAICore/images/Querya.svg'
import quickActionsPath from '../../modules/dependencies/NeosAICore/images/QuickActions.svg'
import remoteInvokePath from '../../modules/Scheduling/images/RemoteInvoke.svg'
import roleUsersPath from '../../modules/dependencies/UserPermissions/images/RoleUsers.svg'
import scheduledTaskLogsPath from '../../modules/Scheduling/images/ScheduledTaskLogs.svg'
import scheduledTaskLogsDarkVersionPath from '../../modules/Scheduling/images/ScheduledTaskLogs.dark.svg'
import schedulerPath from '../../modules/TaskSchedulerShared/images/Scheduler.svg'
import schedulerCronExpressionGenerationPath from '../../modules/TaskSchedulerShared/images/SchedulerCronExpressionGeneration.svg'
import schedulerDisabledPath from '../../modules/TaskSchedulerShared/images/SchedulerDisabled.svg'
import schedulerErrorPath from '../../modules/TaskSchedulerShared/images/SchedulerError.svg'
import schedulerLogLevelErrorPath from '../../modules/TaskSchedulerShared/images/SchedulerLogLevelError.svg'
import schedulerLogLevelInformationPath from '../../modules/TaskSchedulerShared/images/SchedulerLogLevelInformation.svg'
import schedulerLogLevelWarningPath from '../../modules/TaskSchedulerShared/images/SchedulerLogLevelWarning.svg'
import schedulerPendingPath from '../../modules/TaskSchedulerShared/images/SchedulerPending.svg'
import schedulerRunningPath from '../../modules/TaskSchedulerShared/images/SchedulerRunning.svg'
import schedulerSkippedPath from '../../modules/TaskSchedulerShared/images/SchedulerSkipped.svg'
import schedulerSucceededPath from '../../modules/TaskSchedulerShared/images/SchedulerSucceeded.svg'
import schedulerTimeoutExpiredPath from '../../modules/TaskSchedulerShared/images/SchedulerTimeoutExpired.svg'
import settingsPath from '../../modules/Scheduling/images/Settings.svg'
import shortenTextPath from '../../modules/dependencies/NeosAICore/images/ShortenText.svg'
import startTimePath from '../../modules/Scheduling/images/StartTime.svg'
import styleRulePath from '../../modules/dependencies/UICustomization/images/StyleRule.svg'
import styleRuleDarkVersionPath from '../../modules/dependencies/UICustomization/images/StyleRule.dark.svg'
import syncBlackPath from '../../modules/dependencies/UserPermissions/images/SyncBlack.svg'
import translatorPath from '../../modules/dependencies/NeosAICore/images/Translator.svg'
import upPath from '../../modules/dependencies/UserPermissions/images/Up.svg'
import userAccountPath from '../../modules/dependencies/UserPermissions/images/UserAccount.svg'
import userClientPath from '../../modules/dependencies/UserPermissions/images/UserClient.svg'
import userFunctionPath from '../../modules/dependencies/UserPermissions/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/dependencies/UserPermissions/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/dependencies/UserPermissions/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/dependencies/UserPermissions/images/UserPublisher.svg'

const images: Images = {
  aiWritingAssistant: { path: aiWritingAssistantPath, darkVersionPath: aiWritingAssistantDarkVersionPath, colored: true },
  aiWritingAssistantCancel: 'close',
  aiWritingAssistantTaskPerformer: { path: aiWritingAssistantTaskPerformerPath, colored: false },
  aiWritingAssistantValidate: 'validate',
  add: 'add',
  capture: { path: capturePath, colored: false },
  collapse: { path: collapsePath, colored: false },
  correctText: { path: correctTextPath, colored: false },
  createCustomView: { path: createCustomViewPath, darkVersionPath: createCustomViewDarkVersionPath, colored: true },
  customView: { path: customViewPath, colored: false },
  customViewDefaultView: { path: customViewDefaultViewPath, colored: false },
  customViewFilter: { path: customViewFilterPath, colored: false },
  customViewGroups: { path: customViewGroupsPath, colored: false },
  customViewKey: { path: customViewKeyPath, colored: false },
  customViewProperty: { path: customViewPropertyPath, colored: false },
  customViewRelationship: { path: customViewRelationshipPath, colored: false },
  customViewSave: { path: customViewSavePath, colored: false },
  customViewSelected: { path: customViewSelectedPath, colored: false },
  customViewSetDefaultView: { path: customViewSetDefaultViewPath, colored: false },
  customViewSort: { path: customViewSortPath, colored: false },
  dataCreator: 'add',
  down: { path: downPath, colored: false },
  edit: 'edit',
  editCustomView: { path: editCustomViewPath, darkVersionPath: editCustomViewDarkVersionPath, colored: true },
  editUser: 'edit',
  endTime: { path: endTimePath, colored: false },
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  expand: { path: expandPath, colored: false },
  externalCluster: { path: externalClusterPath, colored: true },
  improveText: { path: improveTextPath, colored: false },
  info: 'info',
  jobAndTriggersTests: { path: jobAndTriggersTestsPath, darkVersionPath: jobAndTriggersTestsDarkVersionPath, colored: true },
  neosPrint: 'print',
  omnia: { path: omniaPath, colored: true },
  open: 'open',
  performTaskOnText: { path: performTaskOnTextPath, colored: false },
  quartzNetTrigger: { path: quartzNetTriggerPath, darkVersionPath: quartzNetTriggerDarkVersionPath, colored: true },
  querya: { path: queryaPath, colored: true },
  quickActions: { path: quickActionsPath, colored: false },
  remoteInvoke: { path: remoteInvokePath, colored: false },
  roleUsers: { path: roleUsersPath, colored: false },
  scheduledTaskLogs: { path: scheduledTaskLogsPath, darkVersionPath: scheduledTaskLogsDarkVersionPath, colored: true },
  scheduler: { path: schedulerPath, colored: false },
  schedulerClose: 'close',
  schedulerCronExpressionGeneration: { path: schedulerCronExpressionGenerationPath, colored: true },
  schedulerDisabled: { path: schedulerDisabledPath, colored: true },
  schedulerError: { path: schedulerErrorPath, colored: true },
  schedulerLogLevelError: { path: schedulerLogLevelErrorPath, colored: true },
  schedulerLogLevelInformation: { path: schedulerLogLevelInformationPath, colored: true },
  schedulerLogLevelWarning: { path: schedulerLogLevelWarningPath, colored: true },
  schedulerPending: { path: schedulerPendingPath, colored: true },
  schedulerRunning: { path: schedulerRunningPath, colored: true },
  schedulerSkipped: { path: schedulerSkippedPath, colored: true },
  schedulerSucceeded: { path: schedulerSucceededPath, colored: true },
  schedulerTimeoutExpired: { path: schedulerTimeoutExpiredPath, colored: true },
  settings: { path: settingsPath, colored: false },
  shortenText: { path: shortenTextPath, colored: false },
  startTime: { path: startTimePath, colored: false },
  styleRule: { path: styleRulePath, darkVersionPath: styleRuleDarkVersionPath, colored: true },
  syncBlack: { path: syncBlackPath, colored: false },
  translator: { path: translatorPath, colored: false },
  up: { path: upPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  validate: 'validate',
  vasco: 'open',
  warning: 'warning',
}

export default images